import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="text-center mt-5" style={{ paddingTop: "10%" }}>
      <Row>
        <Col>
          <h1 className="display-1" style={{ color: "#be0028" }}>
            404
          </h1>
          <h2 className="mb-4" style={{ color: "var(--eec-red-color)" }}>
            Page Not Found
          </h2>
          <p className="lead">
            The page you are looking for does not exist. It might have been
            moved or deleted.
          </p>
          <Button variant="btn btn-danger" onClick={() => navigate("/")}>
            Go to Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFoundPage;
